import { render, staticRenderFns } from "./ActivateKiosk.vue?vue&type=template&id=3b5e77a3"
import script from "./ActivateKiosk.vue?vue&type=script&lang=js"
export * from "./ActivateKiosk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports